module.exports = __webpack_public_path__ + "img/base_sensor.52a5a0d8.svg";